<template>
  <DoRight
    ref="right"
    :reportId="reportId"
    :scantron="scantron"
    :answer="answer"
    :current="current"
    :allowPause="false"
    storeKey="homework-seconds"
    :hasNotSupport="false"
    shotAnswerEditable
    :submitTopicFunc="submitTopic"
    @getTopic="onGetTopic"
    @submit="onSubmit"
    :hideSetting="true"
  ></DoRight>
</template>
<script>
import DoRight from '@/components/ques/DoRight.vue';
export default {
  name: 'HomeworkDoRight',
  components: {
    DoRight,
  },
  props: {
    reportId: {},
    scantron: {
      type: Object,
      default: () => {},
    },
    answer: {
      type: Object,
      default: () => {
        return {};
      },
    },
    answerImg: {
      type: Object,
      default: () => {
        return {};
      },
    },
    files: {
      type: Array,
      default: () => [],
    },
    // 区分是否是订正状态
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      current: {},
    };
  },
  computed: {
    total() {
      return this.scantron.list.length;
    },
    answerCount() {
      return this.scantron.list.filter((q) => q.status == 1 || q.status == 2).length;
    },
  },
  methods: {
    init(index) {
      this.$refs.right.init(index);
    },
    async onGetTopic({ reportId, index }) {
      let data = await this.$http.post('/api/app/user/homework/question', {
        report_id: reportId,
        page: index,
        type: this.type ? 'error' : '', // error筛选出错误题
      });
      console.log(
        '---作答_题目信息---',
        `req--${JSON.stringify({
          report_id: reportId,
          page: index,
          type: this.type ? 'error' : '',
        })}`,
        data,
      );
      let ques = data.list[0];
      if (ques.ques_type != 5 && typeof ques.ques_option === 'string') {
        ques.ques_option = JSON.parse(ques.ques_option);
      }
      ques.question_id = ques.ques_id;
      ques.index = index;
      this.current = ques;
      this.$emit('topicChange', ques);
    },
    async submitTopic({ report_id, question_id, user_answer, answer_time, question }) {
      let attachments = [];
      if (question.ques_type == 5) {
        if (
          user_answer != '' ||
          (this.answerImg[question_id] && this.answerImg[question_id].length > 0)
        ) {
          user_answer = JSON.stringify({
            content: user_answer,
            images: this.answerImg[question_id] || [],
          });
        } else {
          // 简单题没答案的情况可退出
          return;
        }
        // 收集附件文件，去掉了
        // for (let item of this.files) {
        //   attachments.push({
        //     url: item.path,
        //     name: item.originalName,
        //   });
        // }
      }
      // 判断是否有答案，没答案不需要保存
      if (!user_answer) return;
      const params = {
        report_id: report_id,
        question_id: question_id,
        user_answer: user_answer,
        answer_time: answer_time,
        attachments: JSON.stringify(attachments),
        version: question.version,
        duration: 1,
      };
      let quesStorage = sessionStorage.getItem(`ques-${question_id}`);
      if (quesStorage) {
        quesStorage = JSON.parse(quesStorage);
        const duration = this.getDuration(quesStorage.viewTime);
        params.duration = duration || 1;
      }
      await this.$http.post('/api/app/user/homework/storeQuestion', params);
      sessionStorage.removeItem(`ques-${question_id}`);
    },
    getDuration(viewTime) {
      return Math.floor((new Date().getTime() - viewTime) / 1000);
    },
    async onSubmit({ id, answer_time, autoSubmit }) {
      const params = {
        report_id: id,
        answer_time: answer_time,
        duration: 1,
      };
      // let quesStorage = sessionStorage.getItem("last-ques");
      // if (quesStorage) {
      //   quesStorage = JSON.parse(quesStorage);
      //   const duration = this.getDuration(quesStorage.viewTime);
      //   params.duration = duration || 1;
      // }
      await this.$http.post('/api/app/user/homework/storeReport', params);
      // sessionStorage.removeItem("last-ques");
      this.$emit('submit', { autoSubmit });
    },
    async navNext() {
      this.$refs.right.navNext();
    },
  },
};
</script>
